var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 45,
    viewBox: "0 0 209 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3031 23.428L49.2006 31.6693L43.6484 31.638L43.909 10.5743L55.7065 10.6386L55.6717 13.4599L49.4264 13.4251L49.3361 20.678L55.5814 20.7127L55.7065 10.6386L61.3403 10.6699L61.1804 23.4905L49.3031 23.428Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.05 26.1172L68.7239 26.0599L68.6857 29.1365L79.6493 29.1973L78.4801 31.7562L63.2969 31.6729L63.481 16.8735L73.807 16.9309L73.774 19.6322L68.8056 19.6149L68.7587 23.3516L73.7271 23.3794L73.807 16.9326L79.1646 16.9621L79.05 26.1172Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8438 31.8135L82.0279 17.0142L97.7653 17.101L96.7612 19.7329L87.3247 19.6808L87.2065 29.2042L97.5603 29.2615L96.4173 31.8934L81.8438 31.8135Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.978 23.4366L116.895 32.0046L110.899 31.9715L105.252 24.0273L105.154 31.9403L99.7969 31.9108L100.057 10.847L105.415 10.8766L105.274 22.2327L110.555 17.1688L117.19 17.2052L110.978 23.4366Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.137 32.1575L119.234 32.0533L119.269 29.3068L132.508 29.3797L132.625 20.0387L138.286 20.07L138.137 32.1575ZM125.153 13.6962L125.075 19.997L132.625 20.0387L132.592 22.7384L119.408 22.6776L119.552 10.9913L139.065 11.099L137.977 13.7674L125.153 13.6962Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.524 20.0056L146.373 32.1678L141.016 32.1383L141.276 11.0746L146.634 11.1041L146.556 17.3685L151.58 17.3963L151.547 20.0247L146.524 20.0056ZM156.781 32.2234L151.397 32.1939L151.581 17.3946L156.965 17.4241L156.781 32.2234Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.365 32.2652L159.008 32.2357L159.192 17.4364L164.55 17.4659L164.365 32.2652ZM159.27 11.172L164.628 11.2015L164.572 15.7443L159.215 15.7148L159.27 11.172Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.331 26.7217L172.005 26.6644L171.967 29.741L182.931 29.8018L181.761 32.3607L166.578 32.2773L166.762 17.478L177.088 17.5354L177.055 20.2367L172.087 20.2193L172.04 23.9561L177.008 23.9839L177.088 17.5371L182.446 17.5666L182.331 26.7217Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.648 32.4094L185.125 32.3799L185.386 11.3162L190.908 11.3457L190.648 32.4094Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.004 11.4446L208.744 32.5083L192.867 32.4214L193.051 17.6221L203.57 17.6795L203.537 20.3079L198.374 20.2888L198.256 29.8122L203.419 29.8399L203.57 17.6777L203.648 11.4133L209.004 11.4446Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5889 22.9816C27.5889 22.9816 28.9613 24.5711 29.8542 27.5591C30.2207 28.7856 23.0964 31.9282 23.0964 31.9282C23.0964 31.9282 26.3624 29.1087 23.3674 27.6651C20.3724 26.2215 17.1482 27.4688 15.0097 19.2275C14.7109 18.0722 13.295 17.6153 12.6245 17.6153C11.0453 17.6153 5.72598 19.8042 5.72598 19.8042C5.72598 19.8042 5.39069 20.3567 5.07626 20.6607C5.07626 20.6607 4.7844 20.9421 4.76008 20.9647C4.44391 21.2687 3.81156 21.5936 3.49713 21.5744C3.21222 21.5571 3.18095 21.5744 2.86478 21.2704C2.665 21.0793 2.54861 20.6607 2.54861 20.3567C2.54861 19.6757 3.412 19.3317 3.81156 19.1389C4.44391 18.8349 5.10753 18.8349 5.39069 19.1389C5.41328 19.1632 5.70687 19.4429 5.67386 19.4429C5.67386 19.4429 5.67386 19.7469 6.62238 19.1389C8.03821 18.2286 11.1826 16.8996 11.7472 16.5522C11.9 16.4584 12.0182 16.3211 12.0825 16.1561C12.2475 15.7357 12.6401 14.8619 13.2585 14.266C13.8909 13.6562 15.7862 12.4384 18.3052 13.7431C22.6725 16.0032 23.0964 15.7635 23.0964 15.7635C23.0964 15.7635 23.9998 14.266 26.5274 11.5264C28.9213 8.93101 31.5827 7.26329 31.5827 7.26329L32.5312 10.0029C32.5312 10.0029 33.4016 9.3462 36.4817 7.36404C36.3913 5.90652 34.8191 4.74433 32.8856 4.74433C32.8856 4.74433 21.8873 0 18.227 0C14.5667 0 3.60657 4.74433 3.60657 4.74433C1.61746 4.74433 0.00532119 5.97428 0.00532119 7.49086C0.00532119 7.49086 -0.175349 23.9023 1.56882 27.6981C4.04956 33.0904 18.2253 44.3771 18.2253 44.3771C18.2253 44.3771 32.0709 33.1912 34.9442 27.7989C35.7486 26.291 36.1568 22.7714 36.3566 19.0798C34.3588 20.9334 31.5445 22.3944 27.5889 22.9816Z",
    fill: "url(#paint0_linear_5536_27277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5536_27277",
    x1: -0.000620091,
    y1: 22.1912,
    x2: 36.4794,
    y2: 22.1912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5226,
    stopColor: "#239BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#1A84BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6086,
    stopColor: "#1373AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6577,
    stopColor: "#0F69A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7202,
    stopColor: "#0E66A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#0661A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList3);
export default __webpack_public_path__ + "static/media/list-3.ed620e8a06762a67475a567131934d09.svg";
export { ForwardRef as ReactComponent };